import { callApi } from '../../../../apiCaller';
import {
     asyncLocalStorage,
     // checkingTestMode,
     couponCodeMessagePossible,
     getTimeZoneLocalStorage,
     jsonAndCompare,
     toastError,
     tryParseJSON,
} from '../../../../utils';

import { API_GUEST_SUBSCRIBER_DETAIL_CART, DEFAULT_FN, LOCAL_CART, LOCAL_COUPON, LOCAL_COUPON_VOUCHERS, LOCAL_ORG_USER } from '../../../../constants';

import { CouponAPI } from '../../../../services/apis/couponAPI';
import { VoucherRuleAPI } from '../../../../services/apis/voucherRuleAPI';
import { CouponVoucherAPI } from '../../../../services/apis/couponVoucherAPI';
import { standardizeCouponVoucher, standardizeCouponVouchers } from '../../../../utils/couponVoucher';

export const SET_CART = 'setCart';
export const EMPTY_CART = 'emptyCart';
export const SET_CART_ITEMS = 'setCartItems';
export const REMOVE_CART_ITEM = 'removeCartItem';
export const ADD_CART_ITEM = 'addCartItem';
export const ADD_CART_COUPON = 'addCartCoupon';
export const REMOVE_CART_COUPON = 'removeCartCoupon';
export const ADD_CART_VOUCHER_RULE = 'addCartVoucherRule';
export const REMOVE_CART_VOUCHER_RULE = 'removeCartVoucherRule';
export const ADD_CART_COUPON_VOUCHERS = 'addCartCouponVouchers';
export const SET_CART_COUPON_VOUCHERS = 'setCartCouponVouchers';
export const REMOVE_CART_COUPON_VOUCHERS = 'removeCartCouponVouchers';
export const CLEAR_CART_COUPON_VOUCHERS = 'clearCartCouponVouchers';
export const CLEAR_CART = 'clearCart';

export const actionSetCart = (cart) => {
     return {
          type: SET_CART,
          payload: cart,
     };
};

export const actionEmptyCart = () => {
     return {
          type: EMPTY_CART,
     };
};

export const actionSetCartItems = (items) => {
     return {
          type: SET_CART_ITEMS,
          payload: items,
     };
};

export const removeCartItem = (id) => {
     return {
          type: REMOVE_CART_ITEM,
          payload: id,
     };
};

export const addCartItem = (item) => {
     return {
          type: ADD_CART_ITEM,
          payload: item,
     };
};

export const actionAddCartCoupon = (coupon) => {
     return {
          type: ADD_CART_COUPON,
          payload: coupon,
     };
};

export const actionRemoveCartCoupon = () => {
     return {
          type: REMOVE_CART_COUPON,
     };
};

export const actionAddCartVoucherRule = (voucherRule) => {
     return {
          type: ADD_CART_VOUCHER_RULE,
          payload: voucherRule,
     };
};

export const actionRemoveCartVoucherRule = () => {
     return {
          type: REMOVE_CART_VOUCHER_RULE,
     };
};

export const actionAddCartCouponVouchers = (code) => {
     return {
          type: ADD_CART_COUPON_VOUCHERS,
          payload: code,
     };
};

export const actionSetCartCouponVouchers = (codes) => {
     return {
          type: SET_CART_COUPON_VOUCHERS,
          payload: codes,
     };
};

export const actionRemoveCartCouponVouchers = (code) => {
     return {
          type: REMOVE_CART_COUPON_VOUCHERS,
          payload: code,
     };
};

export const actionClearCartCouponVouchers = () => {
     return {
          type: CLEAR_CART_COUPON_VOUCHERS,
     };
};

export const actionClearCart = () => {
     return {
          type: CLEAR_CART,
     };
};

export const reloadCartAfterCouponChanged = () => (dispatch) => {
     const cartLocal = tryParseJSON(localStorage.getItem(LOCAL_CART));

     if (cartLocal) {
          dispatch(actionSetCart(cartLocal));
     }
};

export const fetchCartRequest = (cartId) => () => {
     callApi(API_GUEST_SUBSCRIBER_DETAIL_CART.replace(':id', cartId), 'GET').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const { user, organization, sessionId, ...newCart } = response.data;
          localStorage.setItem(LOCAL_CART, JSON.stringify(newCart));
     });
};

export const verifyCoupon =
     (setCouponCodeError = DEFAULT_FN, isRemoveCoupon = false) =>
     async (dispatch, getState) => {
          const user = getState().subscriber.user;
          const cartItems = getState().subscriber.cart.items;
          const coupon = getState().subscriber.cart.coupon;

          if (!cartItems?.length || !coupon?.code) return;

          const localOrganizationUser = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
          const organization = localOrganizationUser.organization;
          const timezone = organization?.timezone || user?.timezone || getTimeZoneLocalStorage();
          const productIds = cartItems.map((cartItem) => cartItem.productId) ?? [];
          const couponPayload = {
               code: coupon.code,
               productIds,
               timezone,
          };

          const result = await CouponAPI.verify(couponPayload);
          if (!result) return;

          if (result.status !== 200) {
               couponCodeMessagePossible(result.message, timezone);
               setCouponCodeError(`This coupon is not valid.`);

               if (isRemoveCoupon) {
                    dispatch(actionRemoveCartCoupon());

                    asyncLocalStorage.removeItem(LOCAL_COUPON).then(() => {
                         dispatch(reloadCartAfterCouponChanged());
                    });
               }

               return;
          }

          const couponResult = result.data;

          if (!jsonAndCompare(coupon, couponResult)) {
               dispatch(actionAddCartCoupon(couponResult));

               asyncLocalStorage.setItem(LOCAL_COUPON, JSON.stringify(couponResult)).then(() => {
                    dispatch(reloadCartAfterCouponChanged());
               });
          }
     };

export const lookupVoucherRule = () => async (dispatch, getState) => {
     const user = getState().subscriber.user;
     const cart = getState().subscriber.cart.cart;
     const cartItems = getState().subscriber.cart.items;

     // // Prevention is only allowed in test environments
     // const isTestMode = checkingTestMode(user);
     // if (!isTestMode) return;

     if (!cart || !cartItems?.length) return;

     const allowedApplyFor = [cart.type.toUpperCase()];

     const payload = {
          userId: user?.id,
          organizationId: cart.organizationId || undefined,
          allowedApplyFor,
          cartItems,
          totalCartOrder: cart.total,
     };

     const result = await VoucherRuleAPI.lookup(payload);

     if (!result.data) {
          dispatch(actionRemoveCartVoucherRule());
          return;
     }

     dispatch(actionAddCartVoucherRule(result.data));

     //FOR CHECK - DO NOT DELETE
     // console.log('Voucher Rule:', result.data);

     return result;
};

export const verifyCouponVouchers = (setIsCodesLoading, setInvalidCodes) => async (dispatch, getState) => {
     const cart = getState().subscriber.cart.cart;
     const cartItems = getState().subscriber.cart.items;

     const localCouponVouchers = tryParseJSON(localStorage.getItem(LOCAL_COUPON_VOUCHERS)) || [];
     const localOrganizationUser = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));

     const couponVoucherCodes = localCouponVouchers.map((cv) => cv.code);
     const organization = localOrganizationUser.organization;

     if (!couponVoucherCodes.length) return false;

     const codePayload = {
          codes: [...couponVoucherCodes],
          cartType: cart.type,
          organizationId: organization?.id || undefined,
          cartItems,
     };

     setIsCodesLoading(true);
     const result = await CouponVoucherAPI.verify(codePayload);
     setIsCodesLoading(false);

     // Update Coupon Local & Redux
     let isCouponChanged = false;

     const { coupon: couponResult, error: errorResult } = result.data;

     if (couponResult) {
          const newCouponResult = { ...couponResult, category: 'coupon' };
          const newStandardizeCoupon = standardizeCouponVoucher(newCouponResult);

          const localCoupon = localCouponVouchers.find((coupon) => coupon.code === newStandardizeCoupon.code);
          isCouponChanged = !!localCoupon && !jsonAndCompare(localCoupon, newStandardizeCoupon);

          if (isCouponChanged) {
               const localCouponIndex = localCouponVouchers.findIndex((coupon) => coupon.code === newStandardizeCoupon.code);
               if (localCouponIndex >= 0) localCouponVouchers[localCouponIndex] = newStandardizeCoupon;

               if (!!localCouponVouchers.length) {
                    const standardizedCouponVouchers = standardizeCouponVouchers(localCouponVouchers);

                    asyncLocalStorage.setItem(LOCAL_COUPON_VOUCHERS, JSON.stringify(standardizedCouponVouchers)).then(() => {
                         dispatch(actionSetCartCouponVouchers(localCouponVouchers));

                         dispatch(reloadCartAfterCouponChanged());
                    });
               }
          }
     }

     // Set Errors
     if (!Object.keys(errorResult).length) return isCouponChanged;

     const { coupons: couponErrs, vouchers: vouchersErrs } = errorResult;
     const errCodes = [...couponErrs, ...vouchersErrs].map((errCode) => errCode.code);
     setInvalidCodes(errCodes);

     return isCouponChanged;
};
